import * as logger from '../datadog-browser-logging';
import {fetchCsrfToken} from '../csrf-token-module.js';

export function doFetch(url, init, callback) {
  if (!init) {
    init = {
      headers: {},
    };
  } else if (!init.headers) {
    init.headers = {};
  }
  init.headers['X-CSRF-Token'] = fetchCsrfToken();

  fetch(url, init)
  .then((rawResponse) => {
    if (!rawResponse.ok) {
      logger.logError('Error while doing fetch call: ' + rawResponse.statusText, {url: url, init: init});
      console.error(rawResponse);
      alert('Ein Fehler(1) ist aufgetreten. Bitte versuche es erneut.');
      return;
    }

    return rawResponse.json();
  })
  .then((response) => {
    if (response.error_csrf) {
      alert('Ein Fehler(3) ist aufgetreten. Bitte lade die Seite neu und versuche es erneut.');
      return;
    }

    callback(response);
  })
  .catch((response) => {
    logger.logError('Error while doing fetch call: ' + response.statusText, {url: url, init: init});
    console.error(response);
    alert('Ein Fehler(2) ist aufgetreten. Bitte versuche es erneut.');
  });
}